import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Image } from "@project-stories/elements/Image/Image";

export default function Carousel({ settings, blocks }) {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const layoutType = isMobile
    ? settings.section.layout_mobile
    : settings.section.layout;
  const rows = isMobile
    ? settings.section.rows_mobile
    : settings.section.rows;
  const gapBetweenBlocksX = isMobile
    ? settings.section.gap_x_mobile
    : settings.section.gap_x;
  const gapBetweenBlocksY = isMobile
    ? settings.section.gap_y_mobile
    : settings.section.gap_y;

  return (
    <div className={`expertise-${layoutType}`}>
      <div className={`flex flex-col items-center text-center pr-3`}>
        <div className={`${isMobile ? settings.section.title_font_type_mobile : settings.section.title_font_type}`}>
          {settings.section.title}
        </div>
        <div className={`mt-6 ${isMobile ? settings.section.subtitle_style_mobile : settings.section.subtitle_style}`}>
          {settings.section.subtitle}
        </div>
      </div>
      <div className="expertise-carousel mt-[60px]"
        data-flickity={`{` +
          `"freeScroll": ${settings.section.use_freescroll}, ` +
          `"wrapAround": true, ` +
          `"cellAlign": "left", ` +
          `"pageDots": ${settings.section.show_indicators}, ` +
          `"prevNextButtons": ${settings.section.show_navbuttons}, ` +
          `"groupCells": 1` +
          `}`}
        {...({
          "x-data": "carousel",
          "x-init": `$nextTick(() => { initialise(${settings.section.show_indicators}, ${settings.section.show_navbuttons}, ${settings.section.fade_edgeitems}, false, 0, 'expertise-carousel', true, ${settings.section.use_freescroll}) })`,
          "x-ref": "carousel",
        })}
      >
        {blocks.reduce((acc, block, index) => {
          if (index % rows === 0) {
            acc.push(blocks.slice(index, index + rows));
          }
          return acc;
        }, []).map((pair, index) => (
          <div
            key={index}
            className={`carousel-cell gap-y-[${gapBetweenBlocksY}px]`}
            style={{
              '--rows': rows,
              marginRight: `${gapBetweenBlocksX}px`,
              maxWidth: `${isMobile ? settings.section.visible_slide_width_mobile : 100}%`,
            }}
          >
            {pair.map((block) =>
              block && (
                <div key={block.key} className="tileitem-border p-6 w-full block-item">
                  <Image imageUrl={block.settings.image_icon} alt={block.settings.title} classes="h-8 w-8" />

                  <div className={`${isMobile ? block.settings.title_font_type_mobile : block.settings.title_font_type} mt-3`}>{block.settings.title}</div>
                  <div className={`${isMobile ? block.settings.content_font_style_mobile : block.settings.content_font_style} mt-2`}>{block.settings.content}</div>
                  {(() => {
                    const texts = Array.from({ length: 4 }, (_, i) => {
                      const key = `text_${i + 1}`;

                      return block.settings[key];
                    }).filter(Boolean);

                    return texts.length > 0 ? (
                      <div className="flex flex-wrap gap-2 mt-5">
                        {texts.map((value, idx) => (
                          <p
                            key={`text_${idx + 1}`}
                            className={`${isMobile ? block.settings.text_font_style_mobile : block.settings.text_font_style} px-3 py-2 rounded-full bg-[#D6CFF8]`}
                          >
                            {value}
                          </p>
                        ))}
                      </div>
                    ) : null;
                  })()}
                </div>
              )
            )}
          </div>
        ))}

      </div>
    </div>
  )
}